import React, { useCallback, useEffect, useState } from "react";
import Loader from "../Common/Loader";
import CommonService from "../../services/common.service";
import moment from "moment";

const MyRank = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(true);
  const [overAllData, setOverAllData] = useState(true);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const fetchData = useCallback(() => {
    setIsLoading(true);
    CommonService.getUserTeamPointRank()
      .then((res) => {
        if (res.success) {
          setOverAllData(res.data);
        }
      })
      .then(() => {
        return CommonService.getPlayerRankStats(user?.id);
      })
      .then((res) => {
        if (res.success) {
          setData(res.data);
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [user?.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>My Rank</h2>
            </div>
            <div className="countdata">
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      Overall Rank
                      <strong>{overAllData?.team_rank}</strong>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      Overall Points
                      <strong>{overAllData?.team_points}</strong>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content" id="myTabContent">
              <div className="pointsystem-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Round</th>
                      <th>Period</th>
                      <th>Points</th>
                      <th>Rank</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, key) => (
                        <tr key={key}>
                          <td>{item.rd}</td>
                          <td>
                            {moment(item.rd_start).format("D.MM.YYYY")} -{" "}
                            {moment(item.rd_end).format("D.MM.YYYY")}
                          </td>
                          <td>{item.points}</td>
                          <td>{item.rd_rank}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyRank;
